/* Growth Serum persona pages: section tracking. gs-lp-track.js, 15 Oct 2026.
   Publishes Shopify custom events that the "GS LP tracking" custom pixel forwards to GA4:
   - lp_section_view  once per section, the first time it is properly in view
   - lp_section_time  time a section was in view (sent when it leaves view, and when the tab is hidden)
   - lp_cta_click     a plan button or link to the offer was clicked
   - lp_exit          last section reached, deepest section, scroll depth, time on page (on tab hide / leave)
   Every event carries persona, page version, market, language and currency (window.gsLp, set in theme.liquid).
   A section counts as "in view" when it covers at least half of the screen, or at least half of the section is visible. */
(() => {
  const ctx = window.gsLp;
  if (!ctx || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
  const wrappers = Array.from(document.querySelectorAll('.shopify-section.sfg-lp-section'));
  if (!wrappers.length) return;
  const keyOf = el => (el.id.split('__').pop() || el.id).replace(/^shopify-section-/, '');
  const t0 = performance.now();
  const state = new Map();
  wrappers.forEach((el, i) => state.set(el, { key: keyOf(el), index: i + 1, seen: false, since: 0, total: 0, sent: 0 }));
  let deepest = 0, last = '', maxScroll = 0, exited = false;
  const base = () => ({ ...ctx, page_ms: Math.round(performance.now() - t0) });
  const send = (name, data) => { try { Shopify.analytics.publish(name, { ...base(), ...data }); } catch (e) {} };
  const flush = (el, s, now) => {
    if (s.since) { s.total += now - s.since; s.since = 0; }
    const ms = Math.round(s.total - s.sent);
    if (ms >= 500) { send('lp_section_time', { section: s.key, section_index: s.index, ms }); s.sent = s.total; }
  };
  const io = new IntersectionObserver(entries => {
    const now = performance.now(), vh = window.innerHeight || 1;
    entries.forEach(en => {
      const s = state.get(en.target); if (!s) return;
      const visible = en.intersectionRect.height;
      const inView = en.isIntersecting && (visible / vh >= 0.5 || en.intersectionRatio >= 0.5);
      if (inView && !s.since) {
        s.since = now;
        last = s.key;
        if (s.index > deepest) deepest = s.index;
        if (!s.seen) { s.seen = true; send('lp_section_view', { section: s.key, section_index: s.index }); }
      } else if (!inView && s.since) {
        flush(en.target, s, now);
      }
    });
  }, { threshold: Array.from({ length: 21 }, (_, i) => i / 20) });
  wrappers.forEach(el => io.observe(el));
  window.addEventListener('scroll', () => {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0) maxScroll = Math.max(maxScroll, Math.round(100 * window.scrollY / h));
  }, { passive: true });
  document.addEventListener('click', ev => {
    const btn = ev.target.closest('.sfg-lp-section [data-gs-plan], .sfg-lp-section a[href^="#offer"], .sfg-lp-section a[href="#protocol"]');
    if (!btn) return;
    const wrap = btn.closest('.shopify-section');
    send('lp_cta_click', { section: wrap ? keyOf(wrap) : '', plan: btn.getAttribute('data-gs-plan') || '', target: btn.getAttribute('href') || 'add_to_cart' });
  }, true);
  const exit = () => {
    const now = performance.now();
    state.forEach((s, el) => flush(el, s, now));
    if (!exited) { exited = true; send('lp_exit', { last_section: last, deepest_index: deepest, sections_total: wrappers.length, scroll_pct: maxScroll }); }
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') exit();
    else { exited = false; const now = performance.now(); state.forEach(s => { if (s.since) s.since = now; }); }
  });
  window.addEventListener('pagehide', exit);
})();
